/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskAverageMonthlyFMVOfSec
 */
export interface ExecRiskAverageMonthlyFMVOfSec {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskAverageMonthlyFMVOfSec
     */
    CurrentYearAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskAverageMonthlyFMVOfSec interface.
 */
export function instanceOfExecRiskAverageMonthlyFMVOfSec(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskAverageMonthlyFMVOfSecFromJSON(json: any): ExecRiskAverageMonthlyFMVOfSec {
    return ExecRiskAverageMonthlyFMVOfSecFromJSONTyped(json, false);
}

export function ExecRiskAverageMonthlyFMVOfSecFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAverageMonthlyFMVOfSec {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'CurrentYearAmt': !exists(json, 'CurrentYearAmt') ? undefined : json['CurrentYearAmt'],
    };
}

export function ExecRiskAverageMonthlyFMVOfSecToJSON(value?: ExecRiskAverageMonthlyFMVOfSec | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'CurrentYearAmt': value.CurrentYearAmt,
    };
}

